import { render, staticRenderFns } from "./JcPayment.vue?vue&type=template&id=0350ea5c&scoped=true"
import script from "./JcPayment.vue?vue&type=script&lang=js"
export * from "./JcPayment.vue?vue&type=script&lang=js"
import style0 from "./JcPayment.vue?vue&type=style&index=0&id=0350ea5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0350ea5c",
  null
  
)

export default component.exports